// extracted by mini-css-extract-plugin
export var cartIcon = "_oy-0";
export var cartIconContainer = "_oy-1";